import * as Actions from './actions/actions'
import { settings } from '../../../settings/settings-util'
import watch from 'redux-watch'
import reducer from './reducers/index'
import Renderers from './renderers/renderers'
import objectpath from 'object-path'

import { playSound, stopSound, updateLastPrvUrl, updatePlayPrvOnNav, getAgentSetting, setShouldPlay, setWasPlayed} from './utils/index'

export default class TTSResponseHandler {
    constructor(passedSettings) {
      this._settings = passedSettings || settings;
      this._renderers = new Renderers(this._settings);
      this._initialized = false;
    }

    static getDefaultSettings() {
        return settings;
    }

    initialize(store) {
        this._store = store;
        this._renderers.initialize(store);

        let playStateWatches = this._settings.stateLocations.TTS.playStateWatches;
        if(playStateWatches && playStateWatches.length)
        {
            playStateWatches.forEach((location) =>
            {
                let initWatcher = watch(this._store.getState, location);
                this._store.subscribe(initWatcher((newVal, oldVal, objectPath) =>
                {
                    return this.handlePlayStateChanged(newVal, oldVal, objectPath);
                }));
            });
        }

        let stopStateWatches = this._settings.stateLocations.TTS.stopStateWatches;
        if(stopStateWatches && stopStateWatches.length)
        {
            stopStateWatches.forEach((location) =>
            {
                let initWatcher = watch(this._store.getState, location);
                this._store.subscribe(initWatcher((newVal, oldVal, objectPath) =>
                {
                    return this.handleMinimizeStateChanged(newVal, oldVal, objectPath);
                }));
            });
        }
    }

    getRenderer() {
      return this._renderers.getRender();
    }

    getReducer() {
         return (state = {}) => { return state; };
    }

    getRealReducer() {
        return reducer;
    }

    doesHandle(response) {
        return (response.messageType === this._settings.messageConstants.converseRequest) ||
            (response.messageType === this._settings.messageConstants.requestUnitRequest) ||
             (response.messageType === this._settings.messageConstants.appeventRequest);
    }

    process(message)
    {
      if(this.doesHandle(message))
      {
        if (Array.isArray(message.response))
        {
          message.response.forEach( (item,index) => {
            this.processSingleResponse(item);
          });
        }
        else
        {
          this.processSingleResponse(message.response);
        }
      }
      return message;
    }

    getPromise() {
        let state = this._store.getState();

        let playSoundOnNav = objectpath.get(state,
            `${this._settings.stateLocations.TTS.Base}.${this._settings.stateLocations.TTS.playPrvOnNav}`);
        if (playSoundOnNav) {
            updatePlayPrvOnNav(this._store, this._settings, false);
            setTimeout(() => this.tryPlaySound(), 500);
        }

        this._initialized = true;
        return Promise.resolve();
    }

    handlePlayStateChanged(newVal, oldVal, objectPath) {
        if (!this._initialized) return;

        let clearSoundAfterDisabling=getAgentSetting(this._settings, 'clearSoundAfterDisabling', true);

        if (newVal) {
            //Enabling sound. Play last repsonse.
            this.tryPlaySound();
        } else {
            //If we are not playing after togging off and then back on we need to clear the current prv.
            if (clearSoundAfterDisabling)
                updateLastPrvUrl(this._store, this._settings, '');

            stopSound(this._store,this._settings);
        }
    }

    tryPlaySound() {
        let lastPrv= this._store.getState()[this._settings.stateLocations.TTS.Base][this._settings.stateLocations.TTS.lastPrvUrl];
        if(lastPrv && lastPrv.prvUrl && lastPrv.ttsInstance && lastPrv.ttsMimeTypes)  {
            playSound(this._store, this._settings,lastPrv.prvUrl, lastPrv.ttsInstance, lastPrv.ttsMimeTypes);
        }
    }

    handleMinimizeStateChanged(newVal, oldVal, objectPath) {
      let stopSoundAfterMinimize=getAgentSetting(this._settings, 'stopSoundAfterMinimize', true);

      if(newVal){
        if(stopSoundAfterMinimize)
          stopSound(this._store,this._settings);
      }
    }

    responseActionsMapper(response, responseAction, settings, store)
    {
      if (responseAction && responseAction.Metadata)
      {
        var sound = responseAction.Metadata.TTSFileID;
        var ttsInstance = responseAction.Metadata.TTSMediaHandlerInstanceID;
        var ttsMimeTypes = responseAction.Metadata.TTSMimeTypes;

        if (sound) {
          var baseUri = settings.AlmeAPI.ALME_API_PROTOCOL + settings.AlmeAPI.ALME_API_HOSTNAME + settings.TTS.TTS_BASE_PATH;
          sound = baseUri + 'MediaHandler.ashx?TTSFileID=' + sound;

          updateLastPrvUrl(this._store, this._settings, sound, ttsInstance, ttsMimeTypes);

          if (response.navUrl && response.navUrl.AutoNavigationType && response.navUrl.AutoNavigationType === "MainPage") {
              updatePlayPrvOnNav(this._store, this._settings, true);
          } else {
            playSound(this._store, this._settings,sound, ttsInstance, ttsMimeTypes);
          }
        }
      }
    }

    processSingleResponse(response)
    {
      response.html = response.html || [];
      if (response && response.responseActions && response.responseActions.length){
        response.responseActions.map((responseAction) => {
          return this.responseActionsMapper(response, responseAction, this._settings, this._store);
        });
      }
    }
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/response-handler-tts/src/response-handler-tts.js